import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import moment from "moment";
@Component({
  selector: "evrideo-separate-time-picker",
  templateUrl: "./separate-time-picker.component.html",
  styleUrls: ["./separate-time-picker.component.scss"],
})
export class SeparateTimePickerComponent implements OnInit {
  @Input() time: moment.Moment;
  @Output() timeChanged = new EventEmitter<moment.Moment>();
  @Output() timeChange = new EventEmitter<moment.Moment>();

  hours: number;
  minutes: number;
  timePeriod: string;
  constructor() {}

  ngOnInit() {
    this.hours = this.time.hours();
    this.minutes = this.time.minutes();
    this.timePeriod = this.time.format("A");
  }

  updateTime(value: string | number, type: string): void {
    this.time.set(type as moment.unitOfTime.Base, Number(value));
    this.timeChanged.emit(this.time);
    this.timeChange.emit(this.time);
  }
}
